// const STIRRED_TANK_VALUE = 2;

export const getChemicalFeasibilityNeutrasorbMag = (
  reactionTime: number,
  targetPh: number,
) => {
  const firstValue = reactionTime >= 60 && targetPh <= 8.5;
  const secondValue = reactionTime >= 30 && targetPh <= 7.5;
  const thirdValue = reactionTime >= 15 && targetPh <= 6;

  return firstValue || secondValue || thirdValue;
};

export const getChemicalFeasibilityOptical = (aeration: string, targetPh: number, t: (value: string) => string) => aeration === t('yes') && targetPh <= 7.8;

export const getChemicalFeasibilityNeutrasorb = (
  targetPh: number,
  reactionTime: number,
  aeration: string,
  stirredTank: string,
  t: (value: string) => string,
) => {
  const firstValue = targetPh <= 4 && reactionTime >= 3;
  const secondValue = aeration === t('yes') && targetPh <= 7.8;
  const thirdValue = aeration === t('no') && targetPh <= 5.5 && reactionTime >= 15;
  const fourthValue =
      aeration === t('no') && targetPh <= 5.5 && stirredTank !== t('stirredTank');

  return firstValue || secondValue || thirdValue || fourthValue;
};

interface IProps {
  product: string;
  reactionTime: number;
  targetPh: number;
  aeration: string;
  stirredTank: string;
  t: (value: string) => string;
}

export const getChemicalFeasibility = ({
  product,
  reactionTime,
  targetPh,
  aeration,
  stirredTank,
  t,
}: IProps) => {
  switch (true) {
    case product.includes('Neutrasorb Mag'): {
      return getChemicalFeasibilityNeutrasorbMag(reactionTime, targetPh);
    }

    case product.includes('Neutrasorb'): {
      return getChemicalFeasibilityNeutrasorb(
        targetPh,
        reactionTime,
        aeration,
        stirredTank,
        t,
      );
    }

    case product.includes('Optical'): {
      return getChemicalFeasibilityOptical(aeration, targetPh, t);
    }

    case product.includes('Neutramaxx'): {
      return true;
    }

    default: {
      return false;
    }
  }
};
